
(function($) {
  // render
  $(document).on('gform_post_render', function(event, form_id, current_page){
    var gravity_form_id = 3; // the formID this JS applies to
    var studentreg_form = $('.table-education-details table');

    if( gravity_form_id === form_id ) {
      var first_cell = studentreg_form.find('tbody tr:first-child td:first-child');
      var second_cell = studentreg_form.find('tbody tr:nth-child(2) td:first-child');
      var first_cell_text = 'Std X/SSC';
      var second_cell_text = 'Std XII/HSC';


      // change the input values, hide the input
      first_cell.find('input').val(first_cell_text).hide();
      second_cell.find('input').val(second_cell_text).hide();



      // then append the text to replace it
      first_cell.html( first_cell.html() + '<div class="placeholder">' + first_cell_text + '</div>' );
      second_cell.html( second_cell.html() + '<div class="placeholder">' + second_cell_text + '</div>' );





    }


  });

  $('.gform_wrapper .educationformlist table.gfield_list select').each(function() {
    var el = $(this);
    var name = el.attr("name");
    var value = el.val();
    el.removeAttr("name");
    el.attr("disabled", true);
    el.after('<input type="hidden" name="' + name + '" value="' + value + '" />');
  });

  // Move asterisks of education details
  $(".educationformlist:eq(0) .gfield_label_before_complex").appendTo(".educationformlist:eq(0) .gfield_list th:eq(0)")
  $(".educationformlist:eq(1) .gfield_label_before_complex").appendTo(".educationformlist:eq(1) .gfield_list th:eq(0)")
  
  $(".cfpcm_certification label").html('How did you hear about CFP <sup>CM</sup> certification program?<span class="gfield_required">*</span>');


})(jQuery);


